import React from 'react';

export default function Dollar() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
		>
			<path
				d="M7 0C3.14012 0 0 3.14012 0 7C0 10.8599 3.14012 14 7 14C10.8599 14 14 10.8599 14 7C14 3.14012 10.8599 0 7 0ZM7.56618 10.3971V10.9632C7.56618 11.2758 7.31294 11.5294 7 11.5294C6.68706 11.5294 6.43382 11.2758 6.43382 10.9632V10.395C5.72971 10.3896 5.08529 10.1323 4.61794 9.66494C4.39682 9.44382 4.39682 9.08559 4.61794 8.86447C4.83906 8.64335 5.19729 8.64335 5.41841 8.86447C5.60082 9.04688 5.92941 9.26471 6.45524 9.26471H7.56618C8.03435 9.26471 8.41524 8.88382 8.41524 8.41565C8.41524 7.94747 8.03435 7.56659 7.56618 7.56659H6.57547C5.48306 7.56659 4.59406 6.67759 4.59406 5.58518C4.59406 4.54094 5.40853 3.69188 6.43424 3.61776V3.03718C6.43382 2.72424 6.68706 2.47059 7 2.47059C7.31294 2.47059 7.56618 2.72424 7.56618 3.03676V3.61118C8.43994 3.65565 8.99788 4.15553 9.17412 4.42812C9.34377 4.69082 9.268 5.04124 9.00529 5.21088C8.74218 5.37929 8.39176 5.30477 8.22294 5.04206C8.22129 5.04206 7.97794 4.73529 7.44594 4.73529H6.57506C6.10688 4.73529 5.726 5.11618 5.726 5.58435C5.726 6.05253 6.10688 6.43341 6.57506 6.43341H7.56576C8.65818 6.43341 9.54718 7.32241 9.54718 8.41482C9.54718 9.50724 8.65859 10.3971 7.56618 10.3971Z"
				fill="#008000"
			/>
		</svg>
	);
}
